import { stringExistsIn } from 'MODULES/validations';
import { checkNested } from 'MODULES/checkNested';

export const isTransportCategory = categorySlug => stringExistsIn('transports-un-tehnika/moto-transports', checkNested(categorySlug, 'lv')) || stringExistsIn('transports-un-tehnika/smagais-transports', checkNested(categorySlug, 'lv')) || stringExistsIn('transports-un-tehnika/vieglie-auto', checkNested(categorySlug, 'lv'));
